<template>
  <header class="app-header" ref="appHeader">
    <nav class="app-header__nav">
      <div
        v-if="!searchStatus"
        class="app-header__logo-container"
        @click="goToTpay"
      >
        <img
          class="app-header__logo"
          :src="
            store.startSettings?.companyLogo
              ? store.startSettings?.companyLogo
              : logo
          "
          alt=""
        />
        <span class="app-header__name">{{
          store.startSettings?.companyName
        }}</span>
        <!-- <span class="app-header__name">The minimalist store gfd</span> -->
      </div>

      <div
        class="app-header__search-container"
        :class="{ 'app-header__search-container--active': searchStatus }"
      >
        <Transition name="slide">
          <label
            for="search"
            ref="inputRef"
            v-if="searchStatus"
            :class="{
              'app-header__label-fade': true,
              'app-header__label-hidden': isFadingOut,
            }"
          >
            <svg
              class="app-header__label-icon"
              width="24"
              height="24"
              viewBox="0 0 24 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.7348 11.4441C17.995 14.8314 15.4534 17.8007 12.0536 18.0727C8.65382 18.3446 5.68981 15.8156 5.42958 12.4284C5.16935 9.04117 7.71094 6.07181 11.1107 5.79988C14.5105 5.52794 17.4745 8.05692 17.7348 11.4441Z"
                stroke="#434343"
                stroke-width="1.5"
              />
              <path
                d="M15.8242 16.9487L19.8469 21.2059"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <input
              class="app-header__input"
              v-model="searchStore.searchValue"
              placeholder="Знайти"
              required=""
              type="text"
              id="search"
              autocomplete="off"
            />
          </label>
        </Transition>

        <button
          v-if="searchStatus"
          @click="resetSearch"
          type="reset"
          class="app-header__btn-close"
        >
          <svg
            class="app-header__close-icon"
            width="14"
            height="14"
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.00879 1.1543L15.4514 15.3073"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M1.15381 15.4512L15.3068 1.00859"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>

      <div class="app-header__buttons" v-if="!searchStatus">
        <button class="app-header__button-search" @click="startSearch">
          <img
            src="@/assets/svg/search-icon.svg"
            alt="icon"
            class="app-header__search-icon"
            width="24"
            height="24"
          />
        </button>
        <!-- <button v-if="store.devMode" -->
        <button @click="goToSaved" class="app-header__saved">
          <svg
            width="24"
            height="22"
            viewBox="0 0 24 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 7.47879C0 13.6934 4.824 17.0045 8.3544 19.9694C9.6 21.0147 10.8 22 12 22C13.2 22 14.4 21.016 15.6456 19.9681C19.1772 17.0058 24 13.6934 24 7.48006C24 1.26673 17.4 -3.14344 12 2.8322C6.6 -3.14344 0 1.26417 0 7.47879Z"
              fill="#434343"
            />
          </svg>
          <div class="app-header__saved-quantity">{{ savedQuantity }}</div>
        </button>
        <!-- <button type="button" class="app-header__lang" id="menu-button">UA
          <img src="@/assets/svg/down.svg" class="app-header__down-icon" alt="icon" width="24" height="24">
        </button> -->
      </div>

      <div v-if="false" id="nav" style="margin: 10px 0">
        <router-link to="/"> Меню </router-link>|
        <router-link to="/basket"> Кошик </router-link>
      </div>
    </nav>
  </header>
</template>
<script setup>
import { ref, watch, nextTick, onMounted, computed } from "vue";
import { useRouter, useRoute } from "vue-router"; // Додаємо імпорт useRouter
import logo from "@/assets/images/logo.png";
import { useSearchStore } from "@/store/searchStore";
import { useStore } from "@/store/getStartStore";
import { useSavedStore } from "@/store/savedStore";

let hostURL = window.location.host.replace(".menu.skyservice.online", "");

if (hostURL.includes("localhost" || "192" || "staging")) {
  hostURL = "staging";
}

const store = useStore();

const searchStore = useSearchStore();
const savedStore = useSavedStore();

const inputRef = ref(null);
const isFadingOut = ref(false);

const router = useRouter(); // Використовуємо useRouter для доступу до роутера
const route = useRoute();

const searchStatus = ref(false);

const appHeader = ref(null);

const savedQuantity = computed(() =>
  savedStore.savedArray ? savedStore.savedArray.length : 0
);

//savedQuantity = array.length

// Функція для стану пошуку
const startSearch = () => {
  router.push("/search");
};

const goToSaved = () => {
  router.push("/saved");
};

const goToTpay = () => {
  if (route.query.menuId) {
    return;
  }

  let tpId = store.startSettings.tableInfo.tableUuid;

  window.location = `https://${hostURL}.tpay.skyservice.online/?tpayid=${tpId}`;
};

// Функція для скидання стану пошуку
const resetSearch = async () => {
  // router.push('/menu');

  isFadingOut.value = true;

  setTimeout(async () => {
    searchStore.searchValue = "";
    searchStatus.value = false;
    isFadingOut.value = false;

    await nextTick(); // Чекаємо, поки Vue оновить DOM перед переходом
    router.push("/");
  }, 200);
};

// onMounted(() => {
//   let headerVisible = ref(true);
//   let scrollPos = ref(window.scrollY);

//   let handleScroll = () => {
//     let scrollTop = window.scrollY;
//     if (headerVisible && scrollTop > scrollPos.value && scrollPos.value !== 0) {
//       headerVisible.value = false;
//       document.querySelector('.product-nav').style.top = '0'
//       document.querySelector('.app-header').style.transform = 'translateY(-100%)'
//     }
//     else if (!headerVisible.value && scrollTop < scrollPos.value) {
//       headerVisible.value = true;
//       document.querySelector('.product-nav').style.top = '70px'
//       document.querySelector('.app-header').style.transform = 'translateY(0)'
//     }

//     scrollPos.value = scrollTop;
//   }

//   window.addEventListener("scroll", handleScroll);
// })

onMounted(() => {
  let lastScrollY = ref(0);
  let isScrollingUp = ref(false);

  let handleScroll = () => {
    if (route.path === "/" || route.path === "/menu") {
      let currentScrollY = window.scrollY;
      if (
        currentScrollY > lastScrollY.value &&
        currentScrollY - lastScrollY.value > 5 &&
        currentScrollY > 50 &&
        document.querySelector(".app-header") &&
        document.querySelector(".product-nav")
      ) {
        isScrollingUp.value = true;
        document.querySelector(".product-nav").style.transform =
          "translateY(-71px)";
        document.querySelector(".app-header").style.transform =
          "translateY(-100%)";
      } else if (
        currentScrollY < lastScrollY.value &&
        lastScrollY.value - currentScrollY > 5 &&
        document.querySelector(".app-header") &&
        document.querySelector(".product-nav")
      ) {
        document.querySelector(".product-nav").style.transform =
          "translateY(0)";
        document.querySelector(".app-header").style.transform = "translateY(0)";
      }

      lastScrollY.value = currentScrollY;
    }
  };

  window.addEventListener("scroll", handleScroll);
});

// Слідкуємо за змінами шляху (url-сторінки)
watch(
  () => route.path,
  async () => {
    if (route.path === "/search") {
      // Якщо у нас шлях '/search', тобто ми на такій сторінці
      searchStatus.value = true;
      await nextTick();
      inputRef.value?.focus();
    } else {
      // Якщо у нас шлях (url-сторінки) не є '/search', тобто ми якійсь іншій сторінці
      searchStatus.value = false;
    }
  },
  { immediate: true }
);

// watch(
//   () => searchStore.searchValue,
//   () => {
//     console.log(searchStore.searchValue, 'searchValue')
//   }
// )
</script>
<style lang="scss" scoped>
.app-header {
  @apply w-full z-30 shrink-0;
  background-color: var(--app-bg);
  position: sticky;
  top: 0;
  transition: transform 0.1s ease-in-out;

  &__nav {
    @apply flex py-[13px] px-[12px] gap-[12px] justify-between items-center;
  }

  &__logo-container {
    cursor: pointer;
    display: flex;
    flex-flow: row;
    gap: 10px;
    align-items: center;
  }

  &__name {
    font-size: 15px;
    font-weight: 600;
    font-family: "Manrope";
    max-width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: var(--text-head);
  }

  &__logo {
    @apply w-[45px] h-[45px] rounded-full;
    object-fit: contain;
  }

  &__buttons {
    //position: fixed;
    display: flex;
    flex-flow: row;
    gap: 14px;
  }

  &__button-search {
    min-width: 45px;
    height: 45px;
    border-radius: 50%;
    background-color: #434343;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: opacity 0.3s ease;
  }

  &__search-icon {
    width: 24px;
    height: 24px;
    color: #434343;
  }

  &__search-container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    width: 0;

    &--active {
      width: 100%;
    }
  }

  &__saved {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background-color: var(--light-grey-color);
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  &__saved-quantity {
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background-color: #de1414;
    color: #ffffff;
    font-size: 9px;
    font-weight: 800;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: 33px;
    left: 33px;
  }

  &__label-fade {
    position: relative;
    width: 100%;
    opacity: 1;
    transform: translateX(0);
    transition: opacity 0.2s ease, transform 0.3s ease;
  }

  &__label-hidden {
    opacity: 0;
    transform: translateX(-20px);
    /* Трохи від'їжджає вліво */
  }

  &__input {
    width: 100%;
    height: 45px;
    border-radius: 60px;
    padding: 12px 2rem 10px 37px;
    background-color: var(--light-grey-color);
    outline: none;
    transition: all 0.3s ease-in-out;

    &:focus {
      border-color: #9ca3af;
      /* Відповідає focus:border-gray-400 */
    }

    &::placeholder {
      color: #434343;
      font-size: 16px;
      font-weight: 500;
    }
  }

  &__label-icon {
    position: absolute;
    left: 0.5rem;
    top: 50%;
    transform: translateY(-50%);
    color: #434343;
  }

  &__close-icon {
    color: #434343;
  }

  &__down-icon {
    margin-right: -4px;
    /* -mr-1 */
    width: 20px;
    /* size-5 */
    height: 20px;
    /* size-5 */
    color: #9ca3af;
    /* text-gray-400 */
  }

  &__btn-close {
    //position: absolute;
    // right: 0.75rem; /* Відповідає right-3 */
    // top: 50%; /* Відповідає top-1/2 */
    // transform: translateY(-50%); /* Відповідає -translate-y-1/2 */
    padding: 0.25rem;
    /* Відповідає p-1 */
    width: 45px;
    height: 45px;
    border-radius: 50%;
    background-color: var(--light-grey-color);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
  }

  &__lang {
    display: flex;
    flex-flow: row;
    justify-content: center;
    align-items: center;
    gap: 5px;
    height: 45px;
    border-radius: 60px;
    padding: 10px;
    background-color: var(--light-grey-color);
    font-weight: 800;
    color: var(--text-head);
    outline: none;
    flex-shrink: 0;
    transition: background-color 0.2s ease-in-out;

    &:hover {
      background-color: #f9fafb;
      /* hover:bg-gray-50 */
    }

    &:focus {
      outline: none;
      box-shadow: inset 0 0 0 1px #d1d5db;
      /* ring-gray-300 ring-inset */
    }
  }
}

/* Початковий стан (до появи) */
/* Початковий стан інпуту (невидимий, зміщений вправо) */
.slide-enter-from {
  opacity: 0;
  transform: translateX(50px);
}

/* Кінцевий стан інпуту (видимий, на місці) */
.slide-enter-to {
  opacity: 1;
  transform: translateX(0);
}

/* Анімація при появі */
.slide-enter-active {
  transition: all 0.2s ease;
}

/* Анімація при зникненні */
.slide-leave-active {
  transition: all 0.2s ease;
  opacity: 0;
  transform: translateX(50px);
}

.hiddenHeder {
  transform: translateY(-100%);
}
</style>
